hns('I18n.currencySymbols', {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "AOA": {
    "symbol": "Kz",
    "name": "Angolan kwanza",
    "symbol_native": "Kz",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AOA",
    "name_plural": "Angolan kwanzas"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLF": {
    "symbol": "UF",
    "name": "Unidad de Fomento",
    "symbol_native": "UF",
    "decimal_digits": 4,
    "rounding": 0,
    "code": "CLF",
    "name_plural": "Unidades de Fomento"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos",
    "alternative_decimal_digits": 2
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "COP",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos",
    "alternative_decimal_digits": 2
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "kr.",
    "name": "Danish Krone",
    "symbol_native": "kr.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Shekel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new shekels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "₹",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "L$",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MNT": {
    "symbol": "MNT",
    "name": "Mongolian Tughrik",
    "symbol_native": "₮",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MNT",
    "name_plural": "Mongolian tögrög"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MRO": {
    "symbol": "UM",
    "name": "Mauritanian ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 1,
    "rounding": 0,
    "code": "MRO",
    "name_plural": "Mauritanian ouguiya"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "kr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PGK": {
    "symbol": "K",
    "name": "Papua New Guinean kina",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PGK",
    "name_plural": "Papua New Guinean kina"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "PLN",
    "name": "Polish Zloty",
    "symbol_native": "PLN",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys",
    "format": "%n %u"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "SEK",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SRD": {
    "symbol": "SR$",
    "name": "Surinamese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SRD",
    "name_plural": "Surinamese dollars"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.S.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.S.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  },
  "ANG": {
    "symbol": "NAƒ",
    "name": "Netherlands Antillean Guilder",
    "symbol_native": "ƒ",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ANG",
    "name_plural": "Netherlands Antillean guilders"
  },
  "AWG": {
    "symbol": "Afl.",
    "name": "Aruban Florin",
    "symbol_native": "Afl.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AWG",
    "name_plural": "Aruban florin"
  },
  "BBD": {
    "symbol": "Bds$",
    "name": "Barbadian Dollar",
    "symbol_native": "Bds$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BBD",
    "name_plural": "Barbadian dollars"
  },
  "BMD": {
    "symbol": "BD$",
    "name": "Bermudian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BMD",
    "name_plural": "Bermudian dollars"
  },
  "BOV": {
    "symbol": "Bolivian Mvdol",
    "name": "Bolivian Mvdol",
    "symbol_native": "Bolivian Mvdol",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOV",
    "name_plural": "Bolivian Mvdol"
  },
  "BSD": {
    "symbol": "B$",
    "name": "Bahamian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BSD",
    "name_plural": "Bahamian dollars"
  },
  "BTN": {
    "symbol": "Nu.",
    "name": "Bhutanese Ngultrum",
    "symbol_native": "Nu.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BTN",
    "name_plural": "Bhutanese ngultrum"
  },
  "BYN": {
    "symbol": "Br",
    "name": "Belarusian Ruble",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BYN",
    "name_plural": "Belarusian rubles"
  },
  "CHE": {
    "symbol": "CHE",
    "name": "WIR Euro",
    "symbol_native": "CHE",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHE",
    "name_plural": "WIR Euro"
  },
  "CHW": {
    "symbol": "CHW",
    "name": "WIR Franc",
    "symbol_native": "CHW",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHW",
    "name_plural": "WIR Franc"
  },
  "COU": {
    "symbol": "COU",
    "name": "Unidad de Valor Real",
    "symbol_native": "COU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "COU",
    "name_plural": "Unidad de Valor Real"
  },
  "CUC": {
    "symbol": "CUC$",
    "name": "Cuban Convertible Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUC",
    "name_plural": "Cuban convertible pesos"
  },
  "CUP": {
    "symbol": "$",
    "name": "Cuban Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUP",
    "name_plural": "Cuban pesos"
  },
  "FJD": {
    "symbol": "FJ$",
    "name": "Fiji Dollar",
    "symbol_native": "FJ$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FJD",
    "name_plural": "Fiji dollars"
  },
  "FKP": {
    "symbol": "£",
    "name": "Falkland Islands Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FKP",
    "name_plural": "Falkland Islands pounds"
  },
  "GIP": {
    "symbol": "£",
    "name": "Gibraltar Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GIP",
    "name_plural": "Gibraltar pounds"
  },
  "GMD": {
    "symbol": "D",
    "name": "Gambian Dalasi",
    "symbol_native": "D",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GMD",
    "name_plural": "Gambian dalasi"
  },
  "GYD": {
    "symbol": "G$",
    "name": "Guyanese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GYD",
    "name_plural": "Guyanese dollars"
  },
  "HTG": {
    "symbol": "G",
    "name": "Haitian Gourde",
    "symbol_native": "G",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HTG",
    "name_plural": "Haitian gourdes"
  },
  "KGS": {
    "symbol": "C",
    "name": "Kyrgyzstani Som",
    "symbol_native": "C",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KGS",
    "name_plural": "Kyrgyzstani som"
  },
  "KPW": {
    "symbol": "₩",
    "name": "North Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KPW",
    "name_plural": "North Korean won"
  },
  "KYD": {
    "symbol": "CI$",
    "name": "Cayman Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KYD",
    "name_plural": "Cayman Islands dollars"
  },
  "LAK": {
    "symbol": "₭",
    "name": "Lao Kip",
    "symbol_native": "₭",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LAK",
    "name_plural": "Lao kip"
  },
  "LRD": {
    "symbol": "L$",
    "name": "Liberian Dollar",
    "symbol_native": "L$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LRD",
    "name_plural": "Liberian dollars"
  },
  "LSL": {
    "symbol": "M",
    "name": "Lesotho Loti",
    "symbol_native": "M",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LSL",
    "name_plural": "Lesotho maloti"
  },
  "MRU": {
    "symbol": "UM",
    "name": "Mauritanian Ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MRU",
    "name_plural": "Mauritanian ouguiya"
  },
  "MVR": {
    "symbol": "Rf",
    "name": "Maldivian Rufiyaa",
    "symbol_native": "Rf",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MVR",
    "name_plural": "Maldivian rufiyaa"
  },
  "MWK": {
    "symbol": "K",
    "name": "Malawian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MWK",
    "name_plural": "Malawian kwacha"
  },
  "MXV": {
    "symbol": "MXV",
    "name": "Mexican Unidad de Inversión",
    "symbol_native": "MXV",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXV",
    "name_plural": "Mexican unidad de inversión"
  },
  "SBD": {
    "symbol": "SI$",
    "name": "Solomon Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SBD",
    "name_plural": "Solomon Islands dollars"
  },
  "SCR": {
    "symbol": "SR",
    "name": "Seychellois Rupee",
    "symbol_native": "SR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SCR",
    "name_plural": "Seychellois rupees"
  },
  "SHP": {
    "symbol": "£",
    "name": "Saint Helena Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SHP",
    "name_plural": "Saint Helena pounds"
  },
  "SLL": {
    "symbol": "Le",
    "name": "Sierra Leonean Leone",
    "symbol_native": "Le",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SLL",
    "name_plural": "Sierra Leonean leones"
  },
  "SSP": {
    "symbol": "SSP",
    "name": "South Sudanese Pound",
    "symbol_native": "SSP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SSP",
    "name_plural": "South Sudanese pounds"
  },
  "STN": {
    "symbol": "Db",
    "name": "São Tomé and Príncipe Dobra",
    "symbol_native": "Db",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "STN",
    "name_plural": "São Tomé and Príncipe dobras"
  },
  "SVC": {
    "symbol": "₡",
    "name": "Salvadoran Colón",
    "symbol_native": "₡",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SVC",
    "name_plural": "Salvadoran colones"
  },
  "SZL": {
    "symbol": "E",
    "name": "Swazi Lilangeni",
    "symbol_native": "E",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SZL",
    "name_plural": "Swazi emalangeni"
  },
  "TJS": {
    "symbol": "TJS",
    "name": "Tajikistani Somoni",
    "symbol_native": "TJS",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TJS",
    "name_plural": "Tajikistani somoni"
  },
  "TMT": {
    "symbol": "T",
    "name": "Turkmenistan Manat",
    "symbol_native": "T",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TMT",
    "name_plural": "Turkmenistan manat"
  },
  "USN": {
    "symbol": "$",
    "name": "US dollar (Next day)",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USN",
    "name_plural": "US dollar (next day)"
  },
  "UYI": {
    "symbol": "UYI",
    "name": "Uruguay Peso en Unidades Indexadas",
    "symbol_native": "UYI",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYI",
    "name_plural": "Uruguay Peso en Unidades Indexadas"
  },
  "VUV": {
    "symbol": "VT",
    "name": "Vanuatu Vatu",
    "symbol_native": "VT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VUV",
    "name_plural": "Vanuatu vatu"
  },
  "WST": {
    "symbol": "WS$",
    "name": "Samoan Tālā",
    "symbol_native": "WS$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "WST",
    "name_plural": "Samoan tālā"
  },
  "XAG": {
    "symbol": "XAG",
    "name": "Silver",
    "symbol_native": "XAG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAG",
    "name_plural": "Silver"
  },
  "XAU": {
    "symbol": "XAU",
    "name": "Gold",
    "symbol_native": "XAU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAU",
    "name_plural": "Gold"
  },
  "XBA": {
    "symbol": "XBA",
    "name": "Bond Markets Unit European Composite Unit (EURCO)",
    "symbol_native": "XBA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBA",
    "name_plural": "Bond Markets Unit European Composite Unit (EURCO)"
  },
  "XBB": {
    "symbol": "XBB",
    "name": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    "symbol_native": "XBB",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBB",
    "name_plural": "Bond Markets Unit European Monetary Unit (E.M.U.-6)"
  },
  "XBC": {
    "symbol": "XBC",
    "name": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)9",
    "symbol_native": "XBC",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBC",
    "name_plural": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)"
  },
  "XBD": {
    "symbol": "XBD",
    "name": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    "symbol_native": "XBD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBD",
    "name_plural": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)"
  },
  "XCD": {
    "symbol": "$",
    "name": "East Caribbean Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XCD",
    "name_plural": "East Caribbean Dollar"
  },
  "XDR": {
    "symbol": "SDR",
    "name": "SDR (Special Drawing Right)",
    "symbol_native": "SDR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XDR",
    "name_plural": "SDR (Special Drawing Right)"
  },
  "XPD": {
    "symbol": "XPD",
    "name": "Palladium",
    "symbol_native": "XPD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPD",
    "name_plural": "Palladium"
  },
  "XPF": {
    "symbol": "CFP",
    "name": "CFP Franc",
    "symbol_native": "CFP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPF",
    "name_plural": "CFP franc"
  },
  "XPT": {
    "symbol": "XPT",
    "name": "Platinum",
    "symbol_native": "XPT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPT",
    "name_plural": "Platinum"
  },
  "XSU": {
    "symbol": "XSU",
    "name": "SUCRE",
    "symbol_native": "XSU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XSU",
    "name_plural": "SUCRE"
  },
  "XUA": {
    "symbol": "XUA",
    "name": "ADB Unit of Account",
    "symbol_native": "XUA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XUA",
    "name_plural": "ADB Unit of Account"
  },
  "ZMW": {
    "symbol": "K",
    "name": "Zambian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZMW",
    "name_plural": "Zambian kwacha"
  },
  "ZWL": {
    "symbol": "Z$",
    "name": "Zimbabwe Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZWL",
    "name_plural": "Zimbabwe dollar"
  }
});
